import {LayoutType} from "./constants";
import {UseFullSizeImages} from "../../../config";
import {getCurrentLayout} from "../../appLayout";

let layouts = {};
Object.keys(LayoutType).forEach(layoutName => {
  layouts[layoutName] = {
    center_island_sink: 3100,
    walls_ceiling: 50900,
    kitchen_floor: 50025,
    // slat_wall: 50020,
    shower_wall_mirror: 50050,
    back_wall: 50100,
    front_wall: 50200,
    left_wall: 50500,
    right_wall: 54000,
    background_bg: 70000,
  };
});

const getLayerDimensions = (layer, currentLayout, canvasDimensions) => {
  const fullImagesFactor = UseFullSizeImages ? 177.77 : 100;
  const sizeFactor = fullImagesFactor / 100;
  const {coords} = layer;

  if (!coords) {
    return null
  }

  const COORDS_MAX = 1;
  const isWallMobile = window.innerWidth <= 1024 && layer.partId.includes("wall");

  const x1Percentage = (coords.min_x * 100) / COORDS_MAX;
  const x2Percentage = (coords.max_x * 100) / COORDS_MAX;
  const y1Percentage = (coords.min_y * 100) / COORDS_MAX;
  const y2Percentage = (coords.max_y * 100) / COORDS_MAX;
  let x1 = sizeFactor*((canvasDimensions.width * x1Percentage) / 100);
  let x2 = sizeFactor*((canvasDimensions.width * x2Percentage) / 100);
  let y1 = sizeFactor*((canvasDimensions.height * y1Percentage) / 100);
  let y2 = sizeFactor*((canvasDimensions.height * y2Percentage) / 100);
  if (!isWallMobile) { // make layer bigger (to add some semi-transparent pixels)
    x1 = x1 - 100;
    x2 = x2 + 100;
    y1 = y1 - 100;
    y2 = y2 + 100;
  }
  return {
    polygonArray: [[x1, y1], [x2, y1], [x2, y2], [x1, y2]],
    width: (x2 - x1),
    height:(y2 - y1)
  };
};

const getMenuByHoveredLayer = (layer) => {
  const layout = getCurrentLayout();
  const featureGroup = layout.getFeatureGroupByPartId(layer.partId);
  if (featureGroup) {
    return {
      parent: featureGroup.getParent().partName,
      child: featureGroup.partName
    }
  }
  return ""
};

export default {
  layouts,
  getMenuByHoveredLayer,
  getLayerDimensions
}


